import React from 'react'
import { SvgIcon } from '@mui/material'

export const SendIcon = props => (
  <SvgIcon
    viewBox="0 0 34 34"
    sx={{ width: '34px', height: '34px', color: 'secondary.main' }}
    {...props}
  >
    <path d="m17.923 17.224-8.536 1.423a.567.567 0 0 0-.438.36l-2.944 7.886c-.282.725.477 1.416 1.173 1.068l20.4-10.2a.85.85 0 0 0 0-1.52l-20.4-10.2c-.696-.348-1.455.343-1.173 1.068l2.944 7.885c.071.19.238.328.438.36l8.536 1.423a.227.227 0 0 1 0 .447Z" />
  </SvgIcon>
)
